import { Heading } from '@frontendmentorio/design-system-v2';

import SharedPlans from 'features/shared/Plans';

export default function Plans() {
  return (
    <section className="px-5 py-8">
      <div
        className="container-xl flex flex-col gap-8 items-center"
        data-testid="plans"
        id="plans"
      >
        <Heading className="text-center" level="3" tagName="h2">
          Choose your billing cycle
        </Heading>

        <SharedPlans />
      </div>
    </section>
  );
}
